let team = [];

let cooridnators = [];
let executives = [];
let mentors = [];
let office = [];

team.forEach((member) => {
	if (member.email.slice(0, 2) === "19") mentors = [...mentors, member];
	else if (member.email.slice(0, 2) === "20")
		cooridnators = [...cooridnators, member];
	else if (member.email.slice(0, 2) === "21")
		executives = [...executives, member];
	if (
		member.email === "19331@iiitu.ac.in" ||
		member.email === "19137@iiitu.ac.in" ||
		member.email === "19307@iiitu.ac.in"
	)
		office = [...office, member];
});

export { cooridnators, executives, mentors, office };

team = [
	{
		title: "Office Bearers",
		members: office,
	},
	{
		title: "Mentors",
		members: mentors,
	},
	{
		title: "Coordinators",
		members: cooridnators,
	},
	{
		title: "Executive Members",
		members: executives,
	},
];

export default team;
